<template>
    <div>
        <div class="progress bg-gray-200 ht-10 mg-b-20">
            <div v-for="(portfolio, index) in portfolios" class="progress-bar" :class="`wd-${portfolio.progress}p`" role="progressbar" v-tooltip:top="`${portfolio.name}: ${portfolio.allocation}`" v-bind:style="{ background: colours(index) + ' !important' }"/>
        </div>
        <table class="table table-sm tx-13 mg-b-0">
            <tbody>
                <tr v-for="(portfolio, index) in portfolios">
                    <td class="align-middle pd-l-0-f">
                        <div class="wd-15 ht-15 rounded-circle bd bd-3" v-bind:style="{ background: colours(index) + ' !important' }"></div>
                    </td>
                    <td class="tx-medium">{{ portfolio.name }}</td>
                    <td class="text-right tx-semibold">{{ portfolio.value|toCurrency(currency) }}</td>
                    <td class="text-right tx-semibold pd-r-0-f">{{ portfolio.allocation }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
	
</style>

<script>
	export default {
		computed: {
			currency: function() {
				return this.portfolioAllocation.datasets[0].options.currency;
			},
			portfolios: function() {
				let portfolios = [];
				const total = this.portfolioAllocation.datasets[0].options.total;

				this.portfolioAllocation.labels.map((name, index) => {
					const value = this.portfolioAllocation.datasets[0].values[0][
						index
					];
					const percentage = total ? (value / total) * 100 : 0;

					const allocation = `${percentage.toFixed(2)}%`;
					const progress = _.round(percentage.toFixed(2), -1);

					portfolios.push({
						name,
						value,
						allocation,
						progress
					});
				});

				return portfolios;
			}
		},
		methods: {
			colours(index) {
				return (
					this.portfolioAllocation.datasets[0].options.colors[index] ||
					this.portfolioAllocation.datasets[0].undefinedColor
				);
			}
		},
		props: ["portfolioAllocation"]
	};
</script>